import React from 'react';
import { Box, Typography } from '@mui/joy';

export default function NotFound() {


  return (

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          <img
            src="/img/404.png"
            alt="Pagina non trovata"
            style={{ maxWidth: '400px', marginBottom: '2rem' }}
          />
          <Typography level="h2">404 - Pagina non trovata</Typography>
          <Typography level="body-md" sx={{ mt: 1 }}>
            La pagina che stai cercando non esiste o è stata spostata.
          </Typography>
        </Box>
  );
}
